import { playGong } from './store';
export function speak(text) {
    console.log(window.speechSynthesis.getVoices());
    const msg = new SpeechSynthesisUtterance();
    const gong = new Audio('/gong.mp3');
    gong.volume = 0.3;
    msg.text = text;
    msg.rate = 0.9;
    msg.lang = 'de-DE';
    let playGongHere = true;
    playGong.subscribe((value) => {
        playGongHere = value;
    });
    if (playGongHere) {
        gong.play();
        gong.onended = () => {
            window.speechSynthesis.speak(msg);
        };
    }
    else {
        window.speechSynthesis.speak(msg);
    }
}
